import React from "react";
import styled from "@emotion/styled";
import { Checkbox } from "antd5";
import { Flex } from "styles/utility-components";

import { countryCodeToCountry } from "../../../../lib/data/optionItems";
import Signal from "../../../../lib/icons/Signal";
import { SupplierTooltip } from "./SupplierTooltip";

import css from "./SupplierCheckbox.module.scss";

type Props = {
  supplier: {
    label: string;
    value: string;
    countryCode?: string | null | undefined;
    totalNotices?: number | null | undefined;
    aliases?: string[] | null | undefined;
    tagLabel?: string;
  };
  selectedSupplierIds: string[];
  onChange: (isChecked: boolean) => void;
  showSignalIcon?: boolean;
  showSupplierCountry?: boolean;
  showTooltip?: boolean;
};
export function SupplierCheckbox({
  supplier,
  selectedSupplierIds,
  onChange,
  showSignalIcon,
  showSupplierCountry = true,
  showTooltip = true,
}: Props) {
  const checkboxContent = (
    <label className={css.labelAndIcon}>
      <Checkbox
        aria-label="Supplier option"
        value={supplier.value}
        name={supplier.label}
        checked={selectedSupplierIds.includes(supplier.value)}
        className={css.label}
        onChange={(e) => onChange(e.target.checked)}
      >
        <div className={css.labelBody}>
          <Flex alignItems="center" gap={12}>
            <span className={css.labelText}>{supplier.label}</span>
            {supplier.tagLabel && <Tag>{supplier.tagLabel}</Tag>}
          </Flex>
          {showSupplierCountry && (
            <span className={css.countryText}>
              {supplier.countryCode && countryCodeToCountry(supplier.countryCode)}
            </span>
          )}
        </div>
      </Checkbox>
      {showSignalIcon && <Signal className={css.signalIcon} size={16} label="signalIcon" />}
    </label>
  );

  return showTooltip ? (
    <SupplierTooltip
      supplierName={supplier.label}
      totalNotices={supplier.totalNotices}
      aliases={supplier.aliases}
    >
      {checkboxContent}
    </SupplierTooltip>
  ) : (
    checkboxContent
  );
}

const Tag = styled.span(({ theme }) => ({
  backgroundColor: theme.colors.sysBackgroundAlternative,
  padding: "2px 6px",
  color: theme.colors.sysTextSecondary,
  fontSize: "12px",
  borderRadius: "4px",
}));
